import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const documentTypesSchema: CollectionCreateSchema = {
  name: CollectionName.DocumentTypes,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      infix: true,
    },
    {
      name: "certificate_types",
      type: "string[]",
      facet: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
